import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';
import { config } from '../../utils/auth_azure';
import { signInRequest } from '../../store/ducks/auth/actions';
import store from '../../store';

export default async function Auth(instance?: PublicClientApplication) {
  const response: AuthenticationResult | undefined = await instance?.loginPopup({
    scopes: config.scopes,
    prompt: 'select_account',
  });
  if (response) {
    console.log(response)
    store.dispatch(signInRequest(response?.accessToken || '', response?.account?.username || ''));
  }
}
